/** Keep in sync with CourseBuilder / My Courses filters */
export const BASE_COURSE_TYPES = [
  'External',
  'Internal',
  'Weapons',
  'Dim Mak',
  'Fitness',
  'Shinobi',
];

export function collapseCourseTypeSpaces(s) {
  return String(s ?? '').trim().replace(/\s+/g, ' ');
}

/** Align DB `course_type` with canonical labels (case-insensitive). */
export function canonicalCourseType(raw) {
  if (raw == null || String(raw).trim() === '') return null;
  const normalized = collapseCourseTypeSpaces(String(raw));
  if (!normalized) return null;
  const k = normalized.toLowerCase();
  const hit = BASE_COURSE_TYPES.find((ct) => ct.toLowerCase() === k);
  return hit || normalized;
}

/**
 * @param {Array<{ course_type?: string | null }>} courses
 * @param {string[]} [extraTypes] Session-added types not yet on any course row.
 */
export function buildCourseTypeOptions(courses = [], extraTypes = []) {
  const seen = new Set();
  const out = [];
  const add = (raw) => {
    const c = canonicalCourseType(raw);
    if (!c) return;
    const k = c.toLowerCase();
    if (seen.has(k)) return;
    seen.add(k);
    out.push(c);
  };
  BASE_COURSE_TYPES.forEach(add);
  courses.forEach((row) => add(row?.course_type));
  extraTypes.forEach(add);
  return out.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}
